import { useContext, useEffect, useState } from 'react';
import { IoCheckmarkDone, IoCheckmark } from "react-icons/io5";
import { useParams } from 'react-router-dom';
import { fetchViewTicketsIdApi, fetchTicketsApi } from "../../services/TicketsApi"
import TicketList from '../../components/TicketList';
import { DataProvider } from '../../store/ContextProvider';
import Loading from '../Loading';

export const ViewTickets = () => {

    const { id } = useParams()

    const { BeURL, handleResolve, currentUser } = useContext(DataProvider);
    const [getTickets, setGetTickets] = useState([]);
    const [getTicketsViewId, setGetTicketsViewId] = useState({})
    const [perPage, setPerPage] = useState(5)
    const [currentPage, setCurrentPage] = useState(1)
    const [totalPages, setTotalPages] = useState(1)
    const [totalCount, setTotalCount] = useState(1)

    useEffect(() => {
        if (id && BeURL) {
            fetchViewTicketsIdApi(setGetTicketsViewId, id, BeURL);
            fetchTicketsApi(setGetTickets, BeURL, perPage, currentPage, setTotalPages, setTotalCount)
        }
    }, [id, BeURL, perPage, currentPage]);

    const handleResolveAction = (ticketId) => handleResolve(ticketId);

    if (!id || !getTickets) {
        return (
            <Loading />
        )
    }

    return (
        <div className="py-6 min-h-[65vh] bg-[#F8F8F8] flex flex-wrap md:flex-nowrap justify-center gap-3">

            {/* Left Column */}
            {
                (Object.keys(getTicketsViewId).length > 0) &&
                <div className="flex flex-col gap-6 w-full md:w-5/12">

                    {/* Profile Card */}
                    <div className="bg-white rounded-2xl shadow-lg overflow-hidden w-full">
                        <div className="p-4 text-primary-500 rounded-t-2xl capitalize">
                            <h2 className="font-bold text-lg md:text-xl">Profile</h2>
                        </div>
                        <div className='w-full h-[1px] bg-gray-100'></div>
                        <div className="p-4 space-y-4 text-sm md:text-base">
                            {['fullName', 'email', 'contact', 'role'].map((field, idx) => (
                                <div key={idx}>
                                    <p className="font-semibold text-gray-700 capitalize">{field.replace('_', ' ')}</p>
                                    <p className="text-gray-500">{getTicketsViewId?.user?.[field]}</p>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Ticket Info */}
                    <div className="bg-white rounded-2xl shadow-lg w-full">
                        <div className='flex flex-col sm:flex-row sm:items-center justify-between p-4 text-white rounded-t-2xl gap-3'>
                            <h2 className="font-bold text-lg text-primary-500">Ticket Information</h2>
                            <span
                                className={`inline-flex items-center justify-center gap-1 px-2 py-1 rounded-full font-semibold text-xs md:text-sm ${getTicketsViewId?.ticket?.status === 'raised'
                                    ? 'bg-yellow-700 text-white'
                                    : 'bg-green-500 text-white'
                                    }`}
                            >
                                {getTicketsViewId?.ticket?.status === 'raised' ? (
                                    <>Pending <IoCheckmark /></>
                                ) : (
                                    <>Resolved <IoCheckmarkDone /></>
                                )}
                            </span>
                        </div>
                        <div className='w-full h-[1px] bg-gray-100'></div>
                        <div className="p-4 space-y-4 text-sm md:text-base">
                            <div>
                                <p className="font-semibold text-gray-700">Ticket ID</p>
                                <p className="text-gray-500">{getTicketsViewId?.ticket?.ticketId}</p>
                            </div>
                            <div>
                                <p className="font-semibold text-gray-700">Subject</p>
                                <p className="text-gray-500">{getTicketsViewId?.ticket?.subject}</p>
                            </div>
                            <div>
                                <p className="font-semibold text-gray-700">Message</p>
                                <p className="text-gray-500">{getTicketsViewId?.ticket?.message}</p>
                            </div>
                            <div>
                                <p className="font-semibold text-gray-700">Created At</p>
                                <p className="text-gray-500">
                                    {getTicketsViewId?.ticket?.createdAt &&
                                        new Date(getTicketsViewId?.ticket?.createdAt).toLocaleString()}
                                </p>
                            </div>

                            {getTicketsViewId?.ticket?.status === 'raised' &&
                                ['admin'].includes(currentUser?.role) && (
                                    <button
                                        type="button"
                                        onClick={() => handleResolveAction(getTicketsViewId?.ticket?.ticketId)}
                                        className="inline-flex items-center gap-1 px-5 py-3 rounded-lg font-bold text-sm 
                             bg-primary-500 hover:bg-primary-600 text-white w-full sm:w-auto"
                                    >
                                        Resolve
                                    </button>
                                )}
                        </div>
                    </div>
                </div>}

            {/* Right Column: Ticket List */}


            <TicketList getTickets={getTickets} perPage={perPage} setPerPage={setPerPage} currentPage={currentPage} setCurrentPage={setCurrentPage} totalPages={totalPages} totalCount={totalCount} />


        </div>
    );
};
